var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgVisibilityOff = function SvgVisibilityOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "visibility_off_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#visibility_off_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FB3C6C",
    d: "m15.45 12.65-.8-.8c.15-.867-.095-1.621-.737-2.263-.642-.641-1.396-.887-2.263-.737l-.8-.8a2.72 2.72 0 0 1 .525-.15c.184-.033.392-.05.625-.05 1.017 0 1.88.354 2.588 1.062.708.709 1.062 1.571 1.062 2.588 0 .233-.017.446-.05.637a2.176 2.176 0 0 1-.15.513Zm3.15 3.075-.75-.675a10.962 10.962 0 0 0 1.688-1.588A8.9 8.9 0 0 0 20.8 11.5c-.833-1.683-2.03-3.021-3.588-4.013C15.654 6.496 13.917 6 12 6c-.483 0-.958.033-1.425.1a9.625 9.625 0 0 0-1.375.3l-.775-.775A9.64 9.64 0 0 1 10.2 5.15c.6-.1 1.2-.15 1.8-.15 2.167 0 4.15.596 5.95 1.787 1.8 1.192 3.125 2.763 3.975 4.713a11.8 11.8 0 0 1-1.363 2.262 10.91 10.91 0 0 1-1.962 1.963Zm1.125 5.425-3.9-3.9c-.433.2-.979.375-1.637.525A9.866 9.866 0 0 1 12 18c-2.183 0-4.166-.596-5.95-1.788A10.87 10.87 0 0 1 2.075 11.5c.384-.883.896-1.713 1.538-2.488.642-.775 1.32-1.42 2.037-1.937l-2.8-2.8.725-.7 16.85 16.85-.7.725ZM6.35 7.775c-.566.417-1.15.958-1.75 1.625a8.244 8.244 0 0 0-1.4 2.1c.834 1.683 2.03 3.02 3.587 4.012C8.346 16.504 10.084 17 12 17c.584 0 1.167-.054 1.75-.163.584-.108 1.025-.22 1.325-.337l-1.65-1.65c-.15.083-.367.154-.65.212a3.855 3.855 0 0 1-.775.088c-1.017 0-1.879-.354-2.587-1.063-.708-.708-1.063-1.57-1.063-2.587 0-.217.03-.463.088-.738.058-.275.129-.504.212-.687l-2.3-2.3Z"
  }))));
};
export default SvgVisibilityOff;